import React from "react";
import styles from "./Slide1.module.scss";
import { useIntl } from "react-intl";
import { messages } from "../../PostProduction.messages";

export const Slide1: React.FC = () => {
  const { formatMessage } = useIntl();

  return (
    <div className={styles.root}>
      <h3>{formatMessage(messages.G4_P4_S1_Title)}</h3>
      <p>{formatMessage(messages.G4_P4_S1_Description)}</p>
      <ul>
        <li>{formatMessage(messages.G4_P4_S1_Item1)}</li>
        <li>{formatMessage(messages.G4_P4_S1_Item2)}</li>
        <li>{formatMessage(messages.G4_P4_S1_Item3)}</li>
        <li>{formatMessage(messages.G4_P4_S1_Item4)}</li>
        <li>{formatMessage(messages.G4_P4_S1_Item5)}</li>
      </ul>
    </div>
  );
};
